<template>


  <div id="dlnkmarket_my_products">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <main id="content" role="main" class="bg-secondary pb-11">

      <h2 class="text-light text-center pt-3">Mes produits</h2>

      <div class="container">

        <div class="card shadow-soft p-4 mt-4">

          <div class="card-body pt-0">

            <div class="row">
              <div class="col-12 ">

                <table id="my-products-list" class="table table-striped table-bordered table-hover">
                  <thead>
                  <tr>
                    <td>Produits</td>
                    <td>Visuel</td>
                    <td>Statut</td>
                    <td>Date création</td>
                    <td>Action</td>
                  </tr>
                  </thead>

                  <tbody>
                  <tr v-for="product in products" :key="product.id">
                    <td>{{ product.name }}</td>
                    <td></td>
                    <td>{{ product.active }}</td>
                    <td>{{ product.created_at }}</td>
                    <td>

                      <button
                          v-if="product.active_id == 88"
                          type="button"
                          name="active_product"
                          data-tooltip="tooltip" title="Reactiver le produit"
                          class="btn btn-sm btn-info"
                          @click="active_product(product.id)">
                        <span><i class="fa fa-fw fa-rocket"></i></span>
                      </button>


                      <button
                          v-if="product.active_id == 2"
                          type="button"
                          name="archive_product"
                          data-tooltip="tooltip" title="Archiver le produit"
                          class="btn btn-sm btn-warning"
                          @click="archive_product(product.id)">
                        <span><i class="fa fa-fw fa-archive"></i></span>
                      </button>

                      <button
                          v-if="product.active_id != 99"
                          type="button"
                          name="delete_product"
                          data-tooltip="tooltip" title="Supprimer le produit"
                          class="btn btn-sm btn-danger"
                          @click="delete_product(product.id)">
                        <span><i class="fa fa-fw fa-trash"></i></span>
                      </button>

                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Form -->

    </main>
  </div>

</template>

<script>

export default {

  data: function () {
    return {
      message_type: "",
      message: "",
      products: Array,
      current_page: Number,
      page_items: Number,
      total_count: Number,
      total_pages: Number,
    }
  },

  mounted() {
    this.current_page = 0
    this.page_items = 0
    this.total_count = 0
    this.total_pages = 0
    this.get_data()
  },

  methods: {

    close_message: function () {
      this.message = null
      this.get_data()
    },

    archive_product: async function (product_id) {
      const _this = this;

      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/products/" + product_id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      const form_data = new FormData();
      form_data.append('product[active]', 'archived')

      axios({
        method: 'patch',
        url: api_url,
        data: form_data,
        headers: {"cache-control": "no-cache"},
      })
          .then(function (response) {
            _this.message = "Produit archivé";
            _this.message_type = "alert-success";
            _this.get_data()
          })
          .catch(function (error) {

            _this.errors = error;
            _this.message = "Une erreur est survenue. Contactez votre support";
            _this.message_type = "alert-danger";
          });

    },

    active_product: async function (product_id) {
      const _this = this;

      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/products/" + product_id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      const form_data = new FormData();
      form_data.append('product[active]', 'online')

      axios({
        method: 'patch',
        url: api_url,
        data: form_data,
        headers: {"cache-control": "no-cache"},
      })
          .then(function (response) {
            _this.message = "Produit activé, il sera en ligne demain matin";
            _this.message_type = "alert-success";
            _this.get_data()
          })
          .catch(function (error) {

            _this.errors = error;
            _this.message = "Une erreur est survenue. Contactez votre support";
            _this.message_type = "alert-danger";
          });

    },

    delete_product: async function (product_id) {
      const _this = this;

      if (confirm('Attention, êtes-vous certain de vouloir supprimer ce produit.')) {

        let [secure_key, customer_id, api_url] = await get_token_2()
        api_url += "/products/" + product_id + ".json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios({
          method: 'delete',
          url: api_url,
          headers: {"cache-control": "no-cache"},
        })
            .then(function (response) {
              _this.message = "Produit supprimé";
              _this.message_type = "alert-success";
              _this.get_data()
            })
            .catch(function (error) {

              _this.errors = error;
              _this.message = "Une erreur est survenue. Contactez votre support";
              _this.message_type = "alert-danger";
            });
      }
    },

    get_data: async function () {

      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/products.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            const headers = response.headers
            _this.products = response.data

            console.log(headers)

            _this.current_page = parseInt(headers["current-page"], 10)
            _this.page_items = parseInt(headers["page-items"], 10)
            _this.total_count = parseInt(headers["total-count"], 10)
            _this.total_pages = parseInt(headers["total-pages"], 10)
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },
  },
}
</script>
